/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum PlaatsingUitzondering {
    PLAATSING_TELT_MEE = "Plaatsing telt mee",
    GEEN_RELEVANTE_PLAATSING = "Geen relevante plaatsing",
    GEEN_1_OKTOBERPLAATSING = "Geen 1-oktoberplaatsing",
    TUSSENTIJDSE_INSTROOM = "Tussentijdse instroom"
}
